var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99813 11.6568C11.4341 11.6568 12.5981 10.4928 12.5981 9.05684C12.5981 7.6209 11.4341 6.45684 9.99813 6.45684C8.56219 6.45684 7.39813 7.6209 7.39813 9.05684C7.39813 10.4928 8.56219 11.6568 9.99813 11.6568Z",
    stroke: "#5E5E62",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0148 7.54017C4.65646 0.323505 15.3481 0.331838 16.9815 7.5485C17.9398 11.7818 15.3065 15.3652 12.9981 17.5818C11.3231 19.1985 8.67313 19.1985 6.9898 17.5818C4.6898 15.3652 2.05646 11.7735 3.0148 7.54017Z",
    stroke: "#5E5E62",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.fb8981a005d17474ad760e2fc3ade6a1.svg";
export { ForwardRef as ReactComponent };